<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="isSelf ? getApplyList : getAllApplyList"
      ref="secondReviewList"
      hide-title-search
      @click:row="getDetails($event.item)"
      :filter-items="isSelf ? [] : filterItems"
      :init-pagination="{ sortBy: 'creationTime', descending: true }"
      clickable
    >
      <template slot="title">
        <span class="pl-2 pr-4">人事部门审核（补卡）</span>
        <v-radio-group mandatory row v-model="isSelf">
          <v-radio :value="true" label="待审核申请"></v-radio>
          <v-radio :value="false" label="历史申请"></v-radio>
        </v-radio-group>
        <v-btn
          flat
          color="primary"
          :loading="loading"
          @click="outputExcel"
          v-if="!isSelf"
          >数据导出</v-btn
        >
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
import { time } from "../../../ladmin/utils/time";
import { exportExcel } from "xlsx-oc";
function reviewStatusTrans(v) {
  switch (v + "") {
    case "1":
      return "已通过";
    case "2":
      return "已拒绝";
    case "0":
      return "待审核";
    case "-1":
      return "N/A";
    default:
      return v;
  }
}
function reviewTypeTrans(v) {
  switch (v + "") {
    case "1":
      return "身体数据异常";
    case "0":
      return "普通补卡";
  }
}
export default {
  name: "secondReviewList",
  components: { LDataTable },
  data() {
    return {
      header: [
        { text: "申请教工", value: "name", sortable: false, align: "left" },
        { text: "教工编号", value: "loginId", sortable: false, align: "left" },
        {
          text: "申请时间",
          value: "creationTime",
          sortable: false,
          align: "left",
          placeholder: "N/A",
          f: (v) => time.stringify(v),
        },
        {
          text: "单位名称",
          value: "orgName",
          sortable: false,
          placeholder: "N/A",
        },
        {
          text: "二级单位审核状态",
          value: "firstAuditStatus",
          sortable: false,
          align: "left",
          f: (v) => reviewStatusTrans(v),
        },
        {
          text: "校医院审核状态",
          value: "medicineAuditStatus",
          sortable: false,
          align: "left",
          f: (v) => reviewStatusTrans(v),
        },
        {
          text: "人事处审核状态",
          value: "secondAuditStatus",
          sortable: false,
          align: "left",
          f: (v) => reviewStatusTrans(v),
        },
      ],
      fileName: "补卡审核数据导出表.xlsx",
      fileHeader: [
        { k: "name", v: "申请教工" },
        { k: "loginId", v: "教工编号" },
        { k: "orgName", v: "单位名称" },
        { k: "creationTime", v: "申请时间" },
        { k: "firstAuditStatus", v: "二级单位审核状态" },
        { k: "medicineAuditStatus", v: "校医院审核状态" },
        { k: "secondAuditStatus", v: "人事处审核状态" },
      ],
      isSelf: true,
      selected: [],
      loading: false,
      hasPermission: false,
      searchSelects: [],
      amount: 0,
      filterItems: [
        {
          prependIcon: "$vuetify.icons.person",
          key: "name",
          value: "",
          label: "教工姓名",
          type: "input",
          layout: ["xs12", "sm4"],
        },
        {
          prependIcon: "$vuetify.icons.person",
          key: "loginId",
          value: "",
          label: "教工编号",
          type: "input",
          layout: ["xs12", "sm4"],
        },
        {
          key: "creationTime",
          value: {},
          label: "申请时间",
          type: "duration",
          layout: ["xs12", "sm4"],
          f: (v) =>
            v
              ? [
                  time.toTimeStamp(v.startDatetime) || 0,
                  time.toTimeStamp(v.endDatetime) || 9999999999999,
                ]
              : [0, 9999999999999],
          range: true,
        },
        {
          prependIcon: "",
          key: "firstAuditStatus",
          value: "",
          label: "二级单位审核",
          type: "select",
          items: [
            {
              value: "0",
              text: "未处理",
            },
            {
              value: "1",
              text: "通过",
            },
            {
              value: "2",
              text: "拒绝",
            },
          ],
          itemValue: "value",
          itemText: "text",
          layout: ["xs12", "sm4"],
        },
        {
          prependIcon: "",
          key: "medicineAuditStatus",
          value: "",
          label: "校医院审核",
          type: "select",
          items: [
            {
              value: "0",
              text: "未处理",
            },
            {
              value: "1",
              text: "通过",
            },
            {
              value: "2",
              text: "拒绝",
            },
          ],
          itemValue: "value",
          itemText: "text",
          layout: ["xs12", "sm4"],
        },
        {
          prependIcon: "",
          key: "secondAuditStatus",
          value: "",
          label: "人事审核",
          type: "select",
          items: [
            {
              value: "0",
              text: "未处理",
            },
            {
              value: "1",
              text: "通过",
            },
            {
              value: "2",
              text: "拒绝",
            },
          ],
          itemValue: "value",
          itemText: "text",
          layout: ["xs12", "sm4"],
        },
      ],
    };
  },
  computed: {
    curOrg() {
      return this.$store.state.login.currentOrg;
    },
  },
  methods: {
    // dealPermission(filter){
    //   let permission = this.$store.state.login.permission
    //   console.log(permission)
    //   if(permission.temp===undefined){
    //     return filter
    //   }
    //   if(permission.temp.graduateAdmin!==undefined){
    //     filter.push({key:'reviewType',value:'3'})
    //     filter.push({key:'firstAuditStatus',value:'1'})
    //     this.hasPermission = true
    //   }else if(permission.temp.scienceAdmin!==undefined){
    //     filter.push({key:'reviewType',value:'1'})
    //     filter.push({key:'firstAuditStatus',value:'1'})
    //     this.hasPermission = true
    //   } else if(permission.temp.undergraduateAdmin!==undefined){
    //     filter.push({key:'reviewType',value:'2'})
    //     filter.push({key:'firstAuditStatus',value:'1'})
    //     this.hasPermission = true
    //   }else if(permission.temp.agentAdmin!==undefined){
    //     filter.push({key:'reviewType',value:'4'})
    //     filter.push({key:'firstAuditStatus',value:'1'})
    //     this.hasPermission = true
    //   }
    //   return filter
    // },
    async getAllApplyList({ pagination, filterItems }) {
      let { items, amount } = await this.$store.dispatch(
        "school/getExtraSignList",
        {
          pagination: pagination,
          filter: filterItems,
        }
      );
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (
          item.firstAuditStatus + "" === "0" ||
          item.medicineAuditStatus + "" === "2"
        ) {
          item.secondAuditStatus = "-1";
        }
      }
      this.amount = amount;
      return { items: items, amount: amount };
    },
    async getApplyList({ pagination }) {
      let filter = [
        { key: "stage", value: "3" },
        { key: "secondAuditStatus", value: "0" },
      ];
      let { items, amount } = await this.$store.dispatch(
        "school/getExtraSignList",
        {
          pagination: pagination,
          filter: filter,
        }
      );
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (
          item.firstAuditStatus + "" === "0" ||
          item.medicineAuditStatus + "" === "2"
        ) {
          item.secondAuditStatus = "-1";
        }
      }
      return { items: items, amount: amount };
    },
    getDetails(item) {
      if (item.secondAuditStatus === "0") {
        this.$router.push({
          name: "signApplyDetail",
          query: {
            id: item.id,
            status: "review",
            type: "3",
          },
        });
      } else {
        this.$router.push({
          name: "signApplyDetail",
          query: {
            id: item.id,
            status: "readonly",
          },
        });
      }
    },
    async getSelection(param) {
      let search = param === undefined ? "" : param.target.value;
      let pagination = { page: 0, rowsPerPage: 10 };
      let params = {
        searchParam: {
          name: {
            index: "1",
            order: "DESC",
            operators: [
              {
                keyword: search,
                operator: "LIKE",
                matchType: "BOTH",
              },
            ],
          },
        },
      };
      let res = await this.$store.dispatch("reservationConfig/getGroups", {
        param: params,
        pagination: pagination,
      });
      if (res.data.status === 1) {
        this.searchSelects = res.data.data.content;
      } else {
        this.searchSelects = [];
      }
    },
    async outputExcel() {
      let pagination = {
        page: 1,
        rowsPerPage: this.amount,
      };
      let { items, amount } = await this.$store.dispatch(
        "school/getExtraSignList",
        {
          pagination: pagination,
          filter: this.filterItems,
        }
      );
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (
          item.firstAuditStatus + "" === "0" ||
          item.medicineAuditStatus + "" === "2"
        ) {
          item.secondAuditStatus = "-1";
        }
      }
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        if (
          item.firstAuditStatus + "" === "0" ||
          item.firstAuditStatus + "" === "2"
        ) {
          item.secondAuditStatus = "-1";
        }
        item.firstAuditStatus = reviewStatusTrans(item.firstAuditStatus);
        item.secondAuditStatus = reviewStatusTrans(item.secondAuditStatus);
        item.medicineAuditStatus =
          reviewStatusTrans(item.medicineAuditStatus) || "N/A";
        item.creationTime = time.stringify(item.creationTime);
      }
      let list = [];
      const ExportJsonExcel = require("js-export-excel");
      let option = {};
      items.forEach((item) => {
        let arr = [];
        for (let i in this.fileHeader) {
          arr.push(item[this.fileHeader[i].k]);
        }
        list.push(arr);
      });
      // console.log(list)
      option.fileName = "人事处补卡申请数据导出表";
      fileHeader: [
        { k: "name", v: "申请教工" },
        { k: "loginId", v: "教工编号" },
        { k: "orgName", v: "单位名称" },
        { k: "creationTime", v: "申请时间" },
        { k: "firstAuditStatus", v: "二级单位审核状态" },
        { k: "medicineAuditStatus", v: "校医院审核状态" },
        { k: "secondAuditStatus", v: "人事处审核状态" },
      ],
        (option.datas = [
          {
            sheetData: list,
            sheetName: "sheet",
            sheetHeader: [
              "申请教工",
              "教工编号",
              "单位名称",
              "申请时间",
              "二级单位审核状态",
              "校医院审核状态",
              "人事处审核状态",
            ],
          },
        ]);
      let toExcel = new ExportJsonExcel(option); //new
      toExcel.saveExcel(); //保存
      this.loading = false;
    },
  },
};
</script>

<style scoped>
</style>
